import { toast } from "sonner";
import { KeyedMutator } from "swr";
import useLocalStorage from "use-local-storage";

import { IOrganizationPromocodePopulated } from "@/backend/domains/organization-promocode/domain/OrganizationPromocode";

import { execAction } from "@/lib/executeServerAction";
import { useServerAction } from "@/hooks/useServerAction";
import { BaseStoreProps, createAdvancedStore } from "@/stores/createAdvancedStore";
import { clientApi } from "@/actions";

//

export interface PromocodeStore extends BaseStoreProps {
  appliedPromocode: IOrganizationPromocodePopulated | null;
  mutate: KeyedMutator<IOrganizationPromocodePopulated | null>;
}

export const promocodeStore = createAdvancedStore<PromocodeStore>("Promocode");
export const usePromocodeStore = promocodeStore.useContext;

//

export function useGetPromocodeStoreData(): PromocodeStore | undefined {
  const [storagedPromocode, setStoragedPromocode] = useLocalStorage<string | null>(
    "promocode",
    null,
  );

  const { data, mutate } = useServerAction<IOrganizationPromocodePopulated | null>(
    { key: "applied-promocode", organizationId: true },
    async () => {
      const getApplied = async () => {
        if (!storagedPromocode) return execAction(clientApi.promocode.getAppliedPromocode);
        const storaged = await clientApi.promocode.applyPromocode(storagedPromocode);
        if (storaged.error !== undefined) {
          toast.error(`Промокод ${storagedPromocode.toUpperCase()}`, {
            description: storaged.error,
          });
        }
        if (storaged.data) {
          toast.success(`Промокод ${storagedPromocode.toUpperCase()} применен`);
        }
        setStoragedPromocode(null);
        return storaged.data ?? null;
      };

      const applied = await getApplied();

      if (applied && applied.applied) return { data: applied };
      return { data: null };
    },
  );

  if (data === undefined) return;

  return { mutate, appliedPromocode: data };
}
